// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { partNumbersStyle } from "@vanmeter/App/ComponentExtensions/ProductPartNumbersExtensions";
import { mergeWithCss } from "@vanmeter/XDL/Utilities";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: QtyNumbersStyles;
    minimumOrderQty?: number;
}

type Props = OwnProps;

export interface QtyNumbersStyles {
    container?: InjectableCss;
    wrapper?: InjectableCss;
    leftSection?: InjectableCss;
    label?: TypographyPresentationProps;
    value?: TypographyPresentationProps;
}

export const qtyNumbersStyles: QtyNumbersStyles = {
    container: {
        css: css`
            display: flex;
        `,
    },
    leftSection: {
        css: css`
            display: flex;
            flex-direction: column;
            flex: 1;
        `,
    },
    wrapper: {
        css: css`
            display: flex;
            flex: 1;
        `,
    },
    label: {
        ...partNumbersStyle.label,
    },
    value: {
        ...partNumbersStyle.value,
    },
};

const QtyNumbers: FC<Props> = ({ extendedStyles, minimumOrderQty }) => {
    const [styles] = React.useState(() => mergeWithCss(qtyNumbersStyles, extendedStyles));
    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.leftSection}>
                {Number(minimumOrderQty) > 0 && (
                    <StyledWrapper {...styles.wrapper}>
                        <Typography {...styles.label}>{translate("Sold in Quantities of")}</Typography>
                        <Typography {...styles.value} data-test-selector="minimumOrderQty">
                            {minimumOrderQty}
                        </Typography>
                    </StyledWrapper>
                )}
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default QtyNumbers;
